var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ds-login-page" }, [
    _c("div", { staticClass: "login-header" }, [
      _vm.logo
        ? _c("img", {
            ref: "logo",
            staticClass: "logo",
            attrs: { src: _vm._f("imgFormat")(_vm.logo), alt: _vm.title },
          })
        : _vm._e(),
      _vm.title
        ? _c("div", { staticClass: "site-name" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
    ]),
    _c(
      "div",
      {
        staticClass: "login-section",
        style: {
          "background-image": _vm.carouselItem
            ? ""
            : "url(" + _vm.backgroundImage + ")",
        },
      },
      [
        _c(
          "div",
          { staticClass: "login-box" },
          [
            _c(
              "el-form",
              {
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm._t("default", function () {
                  return [
                    _vm._t("form", function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "login-box-title single" },
                          [
                            _vm.$loginTemplateList.length == 1
                              ? _c("div", { staticClass: "login-box-normal" }, [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$loginTemplateList[0].name)
                                    ),
                                  ]),
                                ])
                              : _vm._l(_vm.$loginTemplateList, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.template,
                                      staticClass: "login-box-normal",
                                      class: {
                                        "login-box-active":
                                          item.template ===
                                          _vm.loginTemplateActiveTem,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleChangeLogin(
                                            item.template
                                          )
                                        },
                                      },
                                    },
                                    [_c("div", [_vm._v(_vm._s(item.name))])]
                                  )
                                }),
                          ],
                          2
                        ),
                        _c(
                          _vm.loginTemplateActiveTem,
                          _vm._b(
                            {
                              ref: "loginTemplate",
                              tag: "components",
                              attrs: {
                                isShowCode: _vm.isShowCode,
                                codePlaceholder: _vm.codePlaceholder,
                                userNamePlaceholder: _vm.userNamePlaceholder,
                                passwordPlaceholder: _vm.passwordPlaceholder,
                                phonePlaceholder: _vm.phonePlaceholder,
                                codeUrl: _vm.codeUrl,
                                isForgotPassword: _vm.isForgotPassword,
                                loading: _vm.loading,
                              },
                              on: {
                                updateCodeUrl: _vm.updateCodeUrl,
                                toForgotPassword: _vm.toForgotPassword,
                              },
                            },
                            "components",
                            _vm.$attrs,
                            false
                          )
                        ),
                        _c(
                          "div",
                          { staticClass: "login-box-button" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  loading: _vm.loading,
                                  type: "info",
                                  "native-type": "submit",
                                  size: "small",
                                },
                                on: { click: _vm.submit },
                              },
                              [_vm._v("登 录")]
                            ),
                          ],
                          1
                        ),
                      ]
                    }),
                  ]
                }),
              ],
              2
            ),
          ],
          1
        ),
        _vm.carouselItem
          ? _c(
              "el-carousel",
              {
                staticClass: "login-carousel",
                attrs: { interval: _vm.carouselInterval },
              },
              _vm._l(_vm.carouselItem, function (item) {
                return _c("el-carousel-item", { key: item }, [
                  _c("img", { attrs: { src: item } }),
                ])
              }),
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c("div", { staticClass: "login-footer" }, [_vm._t("footer")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }